import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const ssgCustomerCenterButton = {
  title: "SSG.COM 고객센터",
  link: "tel:1577-3419",
  isPhoneLink: true,
};

const common = [
  {
    title: "우천 취소 시 티켓 환불은 어떻게 되나요?",
    content:
      "우천, 미세먼지 등 KBO 규정에 의한 경기 취소 시, 아래와 같은 기준으로 환불됩니다.\n우천취소 확정 이전 고객님께서 직접 취소하신 경우, 취소수수료 및 예매이용료는 환불되지 않으므로 가급적 자동 환불까지 기다려주시기 바랍니다.\n\n환불\n-경기 취소 결정일 다음 영업일에 일괄 취소 처리 됩니다.\n-카드사에 따라 환불은  영업일 기준 3~5일 정도 소요될 수 있습니다.\n\n온라인 예매 건\n-현장 매표소 방문할 필요 없이 일괄 자동 환불됩니다.\n\n현장 매표소 신용카드 구매 건\n-현장 매표소 방문할 필요 없이 일괄 자동 환불됩니다.\n\n현장 매표소에서 현금으로 구매하거나 교환권 혹은 예매권으로 티켓을 교환받은 경우\n-우천취소 직후부터 1루 매표소에 방문하셔야 합니다. 구매한 티켓을 제시하시면 환불/교환됩니다.\n-우천취소 시 1루 매표소는 우천취소 시점으로부터 1시간 후까지 운영합니다.\n\n할인 쿠폰 등을 사용하여 예매한 경우\n-결제 취소 시 쿠폰은 정상 복원됩니다. 복원된 이후 예매 사이트에서 즉시 사용가능합니다.\n\n※ 티켓 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "우천 취소 시 쿠폰은 어떻게 되나요?",
    content:
      "할인 쿠폰 등을 사용하여 예매한 경우\n-결제 취소 시 쿠폰은 정상 복원됩니다. 복원된 이후 예매처에서 사용가능합니다.\n\n※ 티켓 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "티켓 취소했는데 환불이 아직 안 됐어요.",
    content:
      "신용카드 환불은 카드사 정책에 따라 취소 반영 기간의 차이가 있으니 자세한 사항은 해당 카드사로 문의해주세요.\n\n카드사에 따라 환불은  영업일 기준 3~7일 정도 소요될 수 있습니다.\n\n※ 티켓 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "티켓 수령방식 변경 가능할까요?",
    content:
      "티켓 수령 방식은 '지류티켓 → 모바일티켓'으로 변경 가능합니다.\n많은 관중 분들을 대상으로 짧은 입장 시간 내에 수용하기 위해 모바일티켓을 장려하고자, '모바일티켓 → 지류티켓'으로 수령방식 변경은 불가한 점 양해 부탁드립니다.\n\n※ 티켓 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "시즌티켓은 어떻게 구매하나요?",
    content:
      "시즌티켓은 정규 시즌 개막 이전 일정 기간 동안만 판매가 진행됩니다.\n\n판매 기간 이후에는 추가 구매 불가하며, 판매 일정은 SSG랜더스 공식 인스타그램 및 SSG랜더스 APP을 통해 공지 됩니다.\n\n※ 26시즌 시즌티켓은 현재 구매가 마감되었습니다.\n※ 시즌티켓 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [ssgCustomerCenterButton],
  },
  {
    title: "매점에서 결제가 잘못 되었어요.",
    content:
      "인천SSG랜더스필드 내 매점 이용 후 결제 오류가 발생한 경우, 이용하신 매점명/매점 위치/구매 상품/수량/결제일자/결제금액/연락처를 기재하여 SSG랜더스 APP 1:1 문의 또는 SSG랜더스 상담센터로 접수해 주시기 바랍니다.\n접수해 주신 내용을 확인한 후 해당 매장에서 순차적으로 안내드릴 예정이오니 참고 부탁드립니다.",
  },
  {
    title: "이벤트 당첨 여부가 궁금해요.",
    content:
      "신청자 대상 무작위 추첨으로 진행되는 이벤트(사인회, 그라운드 이벤트 등)는 당첨자에 한하여 개별 LMS로 안내가 진행됩니다.\n※ LMS 발송 번호가 스팸 처리된 경우 메시지 수신이 불가할 수 있으니 스팸 설정 여부를 확인해 주시기 바랍니다.",
  },
  // TODO: 확인 필요 - 엑셀 자주하는 질문에 없는 기존 항목이라 문구를 유지함
  // {
  //   title: "생일 쿠폰이 발급되지 않았어요.",
  //   content: "SSG랜더스 APP 회원에게 제공되는 생일 쿠폰은 랜더스 APP 회원가입 시 입력하신 휴대폰 본인 인증 정보를 바탕으로 지급됩니다.\n\n※ APP 가입 이후 일자부터 적용됩니다.\n[SPACE](생일 경과 후 APP 가입 시 당해 생일 쿠폰 미지급)\n\n※ 생일 일자 당일 순차적으로 발급되며, 발급받지 못하신 경우 SSG랜더스 APP 1:1 문의를 남겨주시면 확인 후 안내 도와드리겠습니다. " ,
  //   reference: "",
  // },
  // {
  //   title: "직관 기록이 등록되지 않았어요.",
  //   content: "직관 기록은 SSG랜더스 APP에서 예매한 티켓에 한 해 입장 검표 시 예매 계정으로 자동 직관 기록 처리됩니다.\n\nSSG랜더스 APP 예매가 아닌 경우 티켓 번호를 사용하여 수동 직관 기록이 가능합니다.\n\n[ICON:check]수동 직관 방법\n- SSG랜더스 APP → MY → 직관 기록 → 수동 직관 기록 → 티켓 QR 코드 촬영 or 티켓 번호 입력\n\n※ 수동 직관 기록이 불가한 경우 경기 시간 내 랜더스센터를 방문해 주시면 직원 확인 후 받으실 수 있습니다.\n※ 직관 기록은 경기 당일에만 가능합니다.\n※ 경기 취소(노 게임) 시 적립된 직관 기록은 취소됩니다.\n※ 직관 기록은 계정당 1일 1회만 가능합니다.",
  //   reference: ""
  // },
];


const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline pt-1">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-start">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white transition-[border-radius,border,margin-top] duration-[300ms] ease-[cubic-bezier(0.33,1,0.68,1)] ${state.isEnter ? 'rounded-tl-none rounded-tr-none border-none mt-[-10px]' : ''}`}>
      <p className="font-medium text-gray-950">
        {item.content?.includes("[ICON:") || item.content?.includes("[SPACE]")
          ? formatText(item.content)
          : <span className="whitespace-pre-line">{item.content}</span>}
      </p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map((button) => (
            <LinkItem
              key={button.title}
              title={button.title}
              url={button.link}
              isPhoneLink={button.isPhoneLink}
              styles={"mx-6"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center min-h-12 h-auto px-4 py-2 text-center text-sm leading-snug rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {title}
    </a>
  </li>
);


const FaqPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="자주하는 질문" />
      <div className="bg-transparent p-1 rounded-3xl mb-3 font-medium text-base text-gray-950"></div>
      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("자주하는 질문_전화상담")}
        />
      </div>
    </section>
  );
};

export default FaqPage;
